// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1326": "139b0b334f99","3330": "1852a85dfba9","3573": "ffd50735d5c1","3969": "920ac668affc","4374": "c83d573f50bf","701": "97bf0dd4848c","8540": "d729836002ca",}[chunkId] + ".css"
}